import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import FormLabel from '@material-ui/core/FormLabel'
import FormGroup from '@material-ui/core/FormGroup'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { Select } from './select'
import { RequiredInput } from './input'
import FormHelperText from '@material-ui/core/FormHelperText'

export type Choice = {
  choiceThisYear: string;
  reasonOfChange?: {
    home: boolean;
    serviceStopped: boolean;
    becameAdult: boolean;
    other: boolean;
    otherFromchoice: boolean;
    lawReason?: string;
  }
}

export interface ChoicePickerProps {
  value: Choice;
  onChange: (value: Choice) => void;
  showError?: boolean;
  onErrorChange: (error: boolean) => void;
  doctor?: boolean;
  disabled?: boolean;
}

export const ChoicePicker: React.FC<ChoicePickerProps> = function (props) {
  const { value: choice, onChange, showError = false, onErrorChange, doctor = false, disabled = false } = props
  const [error, setError] = useState(true)
  const [selectError, setSelectError] = useState(true)

  function validate (choice: Choice): boolean {
    setSelectError(!choice.choiceThisYear)
    if (choice.choiceThisYear === 'Po raz kolejny' && choice.reasonOfChange) {
      const reason = choice.reasonOfChange
      const detailError = Number(reason.home) + Number(reason.other) + Number(reason.otherFromchoice) + Number(reason.serviceStopped) + Number(reason.becameAdult) !== 1
      setError(detailError)

      onErrorChange(!choice.choiceThisYear || detailError)

      return !detailError
    }
    setError(false)
    onErrorChange(!choice.choiceThisYear)
    return !!choice.choiceThisYear
  }

  function update(value: string) {
    const newChoice = {
      ...choice,
      choiceThisYear: value
    }

    if (value === 'Po raz kolejny') {
      newChoice.reasonOfChange = {
        home: false,
        other: false,
        otherFromchoice: false,
        serviceStopped: false,
        becameAdult: false
      }
    } else {
      newChoice.reasonOfChange = undefined
    }
    validate(newChoice)
    setSelectError(error)
    
    setTimeout(() => { onChange(newChoice); validate(newChoice) })
  }

  function updateReasonOfChange(key: string, value: boolean) {
    choice.reasonOfChange = {
      home: false,
      other: false,
      otherFromchoice: false,
      serviceStopped: false,
      becameAdult: false
    }
    const newChoice = {
      ...choice,
      reasonOfChange: {
        ...choice.reasonOfChange,
        [key]: value
      }
    }
    validate(newChoice)
    setTimeout(() => { onChange(newChoice) })
  }

  function updateOtherReason(value: string) {
    if (!choice.reasonOfChange) {
      return
    }

    const newChoice = {
      ...choice,
      reasonOfChange: {
        ...choice.reasonOfChange,
        lawReason: value
      }
    }
    validate(newChoice)
    setTimeout(() => { onChange(newChoice) })
  }

  return (
    <Grid container direction="column">
      <Grid item xs>
        <Select disabled={disabled} label="W bieżącym roku dokonuję wyboru:" value={choice.choiceThisYear} onChange={value => update(value)}  options={['Po raz pierwszy lub po raz drugi', 'Po raz kolejny']} error={showError && selectError}/>
      </Grid>
      {
        choice.choiceThisYear === 'Po raz kolejny' && (
          <Grid item xs>
            <FormControl required component="fieldset" error={showError && error}>
              <FormLabel component="legend">okoliczność określona w art. 9 ust. 5 ustawy z dnia 27 października 2017 r. o podstawowej
              opiece zdrowotnej:</FormLabel>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox key={'home'} disabled={disabled} checked={choice.reasonOfChange && choice.reasonOfChange.home} onChange={e => updateReasonOfChange('home', e.target.checked)} />}
                  label="zmiana miejsca zamieszkania"
                />
                <FormControlLabel
                  control={<Checkbox key="servicestop" disabled={disabled} checked={choice.reasonOfChange && choice.reasonOfChange.serviceStopped} onChange={e => updateReasonOfChange('serviceStopped', e.target.checked)} />}
                  label={`zaprzestanie udzielania świadczeń opieki zdrowotnej przez wybranego świadczeniodawcę, ${doctor ? 'lekarza' : 'położną'} podstawowej opieki zdrowotnej u wybranego świadczeniodawcy`}
                />
                { props.doctor && <FormControlLabel
                  control={<Checkbox key="becameadult" disabled={disabled} checked={choice.reasonOfChange && choice.reasonOfChange.becameAdult} onChange={e => updateReasonOfChange('becameAdult', e.target.checked)} />}
                  label={`osiągnięcie 18. roku życia przez świadczeniobiorcę, gdy lekarzem podstawowej opieki zdrowotnej jest lekarz posiadający specjalizację I lub II stopnia lub tytuł specjalisty w dziedzinie pediatrii`}
                />
                }
                <FormControlLabel
                  control={<Checkbox key="otherservice" disabled={disabled} checked={choice.reasonOfChange && choice.reasonOfChange.otherFromchoice} onChange={e => updateReasonOfChange('otherFromchoice', e.target.checked)} />}
                  label="z innych przyczyn powstałych po stronie świadczeniodawcy (podać jakich)"
                />
                <FormControlLabel
                  control={<Checkbox key="other" disabled={disabled} checked={choice.reasonOfChange && choice.reasonOfChange.other} onChange={e => updateReasonOfChange('other', e.target.checked)} />}
                  label="inna okoliczność"
                />
              </FormGroup>
              <FormHelperText>Wybór jednej z opcji jest wymagany</FormHelperText>
            </FormControl>
          </Grid>
        )
      }
      {
        choice.reasonOfChange && choice.reasonOfChange.otherFromchoice && (
          <Grid item xs>
            <RequiredInput value={choice.reasonOfChange.lawReason || ''} error={!choice.reasonOfChange.lawReason} label="Podać przyczyny inne" onChange={updateOtherReason} />
          </Grid>
        )
      }
    </Grid>

  )
}
